import { render, staticRenderFns } from "./Klaviyo.vue?vue&type=template&id=6ec2ce21&scoped=true&"
import script from "./Klaviyo.vue?vue&type=script&lang=js&"
export * from "./Klaviyo.vue?vue&type=script&lang=js&"
import style0 from "./Klaviyo.vue?vue&type=style&index=0&id=6ec2ce21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec2ce21",
  null
  
)

export default component.exports